import { render, staticRenderFns } from "./TablaTrabajadores.vue?vue&type=template&id=38fc6e4e&"
import script from "./TablaTrabajadores.vue?vue&type=script&lang=js&"
export * from "./TablaTrabajadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports